import { useLayoutEffect, useRef } from 'react';
import { Textarea } from '@/components/cms/ui/textarea';

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  minHeightPx?: number;
  // Growth ceiling. Past it the textarea scrolls its own content instead of pushing the
  // step taller, which matters wherever a long minimum makes overflowing text the norm.
  maxHeightPx?: number;
}

export function AutoGrowTextarea({ value, onChange, className = '', placeholder, rows = 3, maxLength, minHeightPx, maxHeightPx }: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    let next = minHeightPx ? Math.max(el.scrollHeight, minHeightPx) : el.scrollHeight;
    if (maxHeightPx) next = Math.min(next, maxHeightPx);
    el.style.height = `${next}px`;
  }, [value, minHeightPx, maxHeightPx]);

  return (
    <Textarea
      ref={ref}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={minHeightPx ? 1 : rows}
      maxLength={maxLength}
      className={`resize-none ${maxHeightPx ? 'overflow-y-auto' : 'overflow-hidden'} ${minHeightPx ? '!min-h-0' : ''} ${className}`}
    />
  );
}
